/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckDocumentSidesConfiguration {
    SINGLE_SIDE_OR_FILE = 'SINGLE_SIDE_OR_FILE',
    MULTIPLE_SIDES_OR_FILES = 'MULTIPLE_SIDES_OR_FILES'
}


export function instanceOfPaxCheckDocumentSidesConfiguration(value: any): boolean {
    for (const key in PaxCheckDocumentSidesConfiguration) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckDocumentSidesConfiguration, key)) {
            if (PaxCheckDocumentSidesConfiguration[key as keyof typeof PaxCheckDocumentSidesConfiguration] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckDocumentSidesConfigurationFromJSON(json: any): PaxCheckDocumentSidesConfiguration {
    return PaxCheckDocumentSidesConfigurationFromJSONTyped(json, false);
}

export function PaxCheckDocumentSidesConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDocumentSidesConfiguration {
    return json as PaxCheckDocumentSidesConfiguration;
}

export function PaxCheckDocumentSidesConfigurationToJSON(value?: PaxCheckDocumentSidesConfiguration | null): any {
    return value as any;
}

export function PaxCheckDocumentSidesConfigurationToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckDocumentSidesConfiguration {
    return value as PaxCheckDocumentSidesConfiguration;
}

